module.exports = __webpack_public_path__ + "img/JinJiang-icon.42e5c963.png";